<template>
  <div
    class="d-explicit-overlay grid-flex grid-middle"
    :class="isSmall ? [ 'small', 'grid-no-response' ] : 'large-font'"
  >
    <DuiIconEyeCrossed
      :class="isSmall ? 'icon-lg' : [ 'icon-xxl', 'space-bottom-1em' ]"
    />

    <p
      :class="isSmall ?
        [ 'space-left-1em', 'space-bottom-none' ] :
        'h4'
      "
    >
      Sensitive content
    </p>

    <p
      v-if="!isSmall"
      class="description space-bottom-2em"
    >
      This book contains sensitive content which some people may
      find offensive or disturbing.
    </p>

    <button
      :class="isSmall ?
        ['button-sm', 'button-circle', 'button-white-bordered', 'space-left-2em' ] :
        'button-grey-medium'
      "
      type="button"
      @click.capture="buttonClick($event)"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    buttonClick(event) {
      this.$emit('button-click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-explicit-overlay {
  flex-direction: column;
  justify-content: center;
  padding: $_2em;
  text-align: center;

  &.small {
    flex-direction: row;
    padding: 0;
    text-align: left;

    p {
      font-weight: $base-weight-bold;
    }
  }

  .h4,
  .description {
    font-family: $base-font;
  }

  .description {
    max-width: 50 * $_1em;
  }
}
</style>
